/**
 * Labstep
 *
 * @module components/ProtocolStep/Item
 * @desc ProtocolStep Item
 */

import { ProtocolStepActionComplete } from 'labstep-web/components/ProtocolStep/Action/Complete';
import { ICONS } from 'labstep-web/constants/icons';
import { ElementCard } from 'labstep-web/core/Card/Element';
import { SubHeader } from 'labstep-web/core/SubHeader';
import { Experiment } from 'labstep-web/models/experiment.model';
import type React from 'react';
import styles from './styles.module.scss';
import type { IProtocolStepItemProps } from './types';

export const ProtocolStepItem: React.FC<IProtocolStepItemProps> = ({
  protocolStep,
  protocol,
  index,
}) => {
  const stepNumber = index + 1;
  const elementCardProps =
    protocol instanceof Experiment
      ? {
          customIcon: (
            <ProtocolStepActionComplete
              protocol={protocol}
              protocolStep={protocolStep}
            />
          ),
          name: (
            <div
              data-cy="components/ProtocolStep/Item"
              onClick={(evt) => evt.preventDefault()}
              className={styles.previewContainer}
            >
              <SubHeader>{`STEP ${stepNumber}`}</SubHeader>
            </div>
          ),
        }
      : {
          icon: ICONS.protocol.step,
          name: `Step ${stepNumber}`,
        };

  return (
    <a
      href="javascript:void(0);"
      onClick={(e) => {
        const stepElement = document.querySelector(
          `[data-protocol_step-id="${protocolStep.guid}"]`,
        );

        if (stepElement instanceof HTMLElement) {
          stepElement.scrollIntoView();
        }

        e.preventDefault();
      }}
    >
      <ElementCard {...elementCardProps} />
    </a>
  );
};
